export default "__VITE_ASSET__tc1AhC3h__"